<template>
  <div>
    <ADataTable
      :headers="headers"
      :api="api"
      :apiParams="apiParams || apiParamsDefault"
      :sortBy="'TimestampFormatted'"
      :sortDesc="true"
      :hideAutoRefreshBox="true"
      :exportable="exportable"
      :autoRefreshInitVal="autoRefresh"
      :viewAction="true"
      :actionsAtFirst="true"
      @click:view="onRowClick"
      ref="table"
    />
    <CartModal ref="cartModal"></CartModal>
  </div>
</template>


<script>
import snackbarMixin from "../mixins/snackbar";
import CartsLogMixin from "../mixins/CartsLog";
import CRUDFuncsMixin from "../mixins/CRUDFuncs";
import ADataTable from "../components/ADataTable";
import CartModal from "../components/CartModal";

export default {
  name: "CartsLog",
  props: ["hideTitleBar", "autoRefresh", "exportable", "apiParams"],
  mixins: [snackbarMixin, CartsLogMixin, CRUDFuncsMixin],
  components: {
    ADataTable,
    CartModal
  },
  data: () => ({
    model: "cartscanlog",
    apiParamsDefault: {
      queryType: "latest"
    }
  }),
  computed: {},
  methods: {
    refresh() {
      this.$refs.table.load();
    },
    onRowClick(ob) {
      this.$refs.cartModal.open(ob.CartId);
    }
  }
};
</script>


<style>
</style>

